import { render, staticRenderFns } from "./AssignmentProgress.vue?vue&type=template&id=31682f12&scoped=true&"
import script from "./AssignmentProgress.vue?vue&type=script&lang=js&"
export * from "./AssignmentProgress.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentProgress.vue?vue&type=style&index=0&id=31682f12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31682f12",
  null
  
)

export default component.exports